"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpControlButton = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var __1 = require("../..");
var DpControlButton_styled_1 = require("./DpControlButton.styled");
var DpControlButton = function (_a) {
    var name = _a.name, clickHandler = _a.clickHandler, disabled = _a.disabled, _b = _a.className, className = _b === void 0 ? '' : _b;
    return ((0, jsx_runtime_1.jsx)(__1.DpLoadingWrapper, { onClick: clickHandler, as: DpControlButton_styled_1.StyledControlButton, variant: "light", className: className, disabled: disabled, replaceChildren: true, children: (0, jsx_runtime_1.jsx)(__1.Icon, { name: name, className: "text-size-xl" }) }));
};
exports.DpControlButton = DpControlButton;
exports.default = exports.DpControlButton;
